<template>
    <div class="se-main">
        <!-- <pp-header></pp-header> -->
        <transition name="van-fade" mode="out-in">
            <keep-alive><router-view v-if="$route.meta.keepAlive"></router-view></keep-alive>
        </transition>
        <transition name="van-fade" mode="out-in"><router-view v-if="!$route.meta.keepAlive"></router-view></transition>
    </div>
</template>
<script>
// 主体
// import ppHeader from './header.vue';
export default {
    name: 'se-main',
    components: {
        // ppHeader
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
.se-main {
}
</style>
